
import { Box, Button, Typography, useMediaQuery } from "@mui/material";
import React, { useEffect } from "react";
import {
  BGColor02,
  bgColor07,
  blackColor,
  blackShade05,
  blueColor04,
  greyColor060,
  mobilePrimary,
  whiteColor,
} from "../configs/styles/muiThemes";
import DashboardLayout from "../components/Layouts/DashboardLayout";
import { stickyHeader } from "../utils/styles";
import OrderReportsContent from "./OrderReports/OrderReportsContent";
import MobileEmptyCard from "./OrderReports/MobileEmptyCard";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import DescriptionIcon from "@mui/icons-material/Description";
import { useDispatch, useSelector } from "react-redux";
import { getStatsCountInfoData } from "../reducers/businessDashboard/BusinessDashboardSlice";
import CatalogInventoryReportContent from "./CatalogInventoryReport/CatalogInventoryReportContent";

function CatalogInventoryReport() {
  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));

  const dispatch = useDispatch();

  const { statsCountInfo } = useSelector((state) => state.businessDashboard);

  useEffect(() => {
    const businessId = sessionStorage.getItem("selectedBusinessId");

    if (!statsCountInfo) {
      dispatch(getStatsCountInfoData(businessId));
    }
  }, []);
  return (
    <Box sx={styles.container}>
      <DashboardLayout
        activeMenu="report"
        activeSubMenu="catalogInventoryReport"
      >
        <Box
          sx={
            {
              // ...stickyHeader,
              // pb: { md: 1, xs: 0 },
              // pt: 2,
              // px: 0,
              // // top: 100,
              // backgroundColor: bgColor07,
            }
          }
        >
          {matches ? (
            <CatalogInventoryReportContent statsCountInfo={statsCountInfo} />
          ) : (
            <MobileEmptyCard
              icon={
                <DescriptionIcon sx={{ fontSize: "26px", color: whiteColor }} />
              }
              iconBGColor={mobilePrimary}
              // message={"Price Analysis feature is currently available only on our browser web version.For the best experience and to use this feature, please switch to a desktop or laptop computer and access our site through a standard web browser We appreciate your understanding"}
            />
          )}
        </Box>
      </DashboardLayout>
    </Box>
  );
}

export default CatalogInventoryReport;



const styles = {
  container: {
    minHeight: { xs: "calc(100vh - 91px)", md: "100vh" },
    backgroundColor: BGColor02,
  },

  content: {
    display: "flex",
    flexDirection: "column",
    gap: { xs: "20px", md: "20px" },
    p: { xs: "0px", md: "15px 25px 25px 25px" },
    mx: { xs: "15px", md: "0px" },
  },

  stickyTop: {
    position: "sticky",
    top: 0,
    width: "100%",
    zIndex: 100,
    pb: 1.5,
    backgroundColor: BGColor02,
  },

  menuStickyLeft: {
    position: { md: "sticky", xs: "static" },
    top: 0,
    left: 0,
    height: "100vh",
    zIndex: 100,
    backgroundColor: BGColor02,
  },
};
